/** @format */

import { useEffect } from "react";
import Navbar from "../shared/components/navbar";
import Footer from "../shared/components/footer";
import { Helmet } from "fusion-plugin-react-helmet-async";
import { assetUrl } from "fusion-core";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "fusion-plugin-react-router";
import useAppStateStore from "../shared/store/AppStateStore";
import QuoteStep from "../features/quote/enums/QuoteStep";
import { TrackHotjarEvent } from "../shared/utils/trackHotjarEvent";
import { HotjarEventNames } from "../shared/utils/hotjarEventNames";
import { goBackToLastStep } from "../shared/utils/navigationUtils";
import PageContent from "../shared/components/PageContent";
import QuoteFormWrapper from "../shared/components/quoteFormWrapper";
import QuoteStepHeading from "../shared/components/QuoteStepHeading";
import Button from "../shared/components/Button";

const ErrorPage = () => {
  const mainCss = assetUrl("../styles/main.css");
  const [searchParams] = useSearchParams();
  const errorUrl = searchParams.get("url");
  const navigate = useNavigate();
  const rawMessage = searchParams.get("message");
  const parsedMessage = decodeURIComponent(rawMessage || "");
  const ServerErrorImage = assetUrl("../assets/images/error_500.jpg");
  const STATE = useAppStateStore();

  const handleRetry = () => {
    if (
      parsedMessage ===
      "You're not logged in, please click retry to login and then proceed."
    ) {
      navigate("/");
    } else if (parsedMessage === "Timed Out") {
      navigate("/taxi/quote/start");
      STATE.setMemberRetry && STATE.setMemberRetry(true);
    } else {
      // clearAllStores();
      navigate("/taxi/quote/start");
      if (STATE.currentStep === QuoteStep.TQ_PANEL_LOADER) {
        goBackToLastStep();
      }
    }
  };

  useEffect(() => {
    TrackHotjarEvent(HotjarEventNames.TAXI_ERROR_SERVER);
  }, []);

  return (
    <>
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />
        <meta name="robots" content="noindex, nofollow" />
        <link rel="stylesheet" href={mainCss} />
      </Helmet>
      <Navbar />
      <PageContent className="tw-flex tw-flex-col tw-items-center">
        <div className="tw-mx-auto tw-w-full tw-max-w-dis-card">
          <QuoteFormWrapper>
            <img
              src={ServerErrorImage}
              alt=""
              className="tw-mb-5 tw-h-auto tw-w-full tw-rounded-[10px]"
            />
            <QuoteStepHeading
              title="Error! Something went wrong."
              description="We apologize for the inconvenience. You can contact support by clicking the icon at the bottom right of your screen, or try again by clicking the button below."
              className="tw-mb-6"
              descriptionClassName="tw-text-base tw-text-dis-text-2"
            />

            {parsedMessage ? (
              typeof parsedMessage === "object" ? (
                <pre className="tw-m-0 tw-whitespace-pre-wrap tw-break-words tw-border-0 tw-border-l-4 tw-border-solid tw-border-l-dis-error tw-bg-dis-error-bg tw-p-3 tw-text-sm tw-text-dis-error">
                  {JSON.stringify(parsedMessage, null, 2)}
                </pre>
              ) : (
                <p
                  className="tw-m-0 tw-border-0 tw-border-l-4 tw-border-solid tw-border-l-dis-error tw-bg-dis-error-bg tw-p-3 tw-text-sm tw-text-dis-error"
                  role="alert"
                >
                  {parsedMessage}
                </p>
              )
            ) : (
              errorUrl && (
                <p
                  className="tw-m-0 tw-border-0 tw-border-l-4 tw-border-solid tw-border-l-dis-error tw-bg-dis-error-bg tw-p-3 tw-text-sm tw-text-dis-error"
                  role="alert"
                >
                  Failed to fetch from: {errorUrl}
                </p>
              )
            )}

            <Button
              type="button"
              size="large"
              fullWidth
              className="tw-mt-6"
              onClick={handleRetry}
            >
              Retry
            </Button>
          </QuoteFormWrapper>
        </div>
      </PageContent>
      <Footer />
    </>
  );
};

export default ErrorPage;
